import { styled } from '@mui/material/styles'
import { Link as RouterLink } from 'react-router-dom'
// material
import { Box, Button, Container } from '@mui/material'
// components
import Page from '../components/Page'
import { commonBtnStyles } from 'components/request-action/styles/styles'

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  alignItems: 'center',
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('xl')]: {
    paddingTop: theme.spacing(15)
  }
}))

// ----------------------------------------------------------------------

export default function NoNotifications(props) {
  return (
    <RootStyle title={props?.title}>
      <Container>
        <Box sx={{ maxWidth: 300, maxHeight: 300, margin: 'auto', textAlign: 'center' }}>
          <Button
            to="/dashboard/app"
            sx={{ ...commonBtnStyles }}
            size="large"
            variant="contained"
            component={RouterLink}
          >
            Go to Guarantee List
          </Button>
        </Box>
      </Container>
    </RootStyle>
  )
}
